@if (onAuthRoute()) {
  <router-outlet />
} @else {
  <div class="shell">
    <aside class="sidebar">
      <div class="brand">
        <span class="mark">e</span>
        <div class="brand-text">
          <span class="word">enfin</span>
          <span class="tag">Accounting</span>
        </div>
      </div>

      @if (isAuthenticated()) {
        <app-create-menu class="sidebar-new" />
      }

      <nav>
        @for (group of navGroups(); track group.title) {
          <div class="nav-group">
            <div class="nav-title">{{ group.title }}</div>
            @for (item of group.items; track item.path) {
              <a [routerLink]="item.path" routerLinkActive="active" class="nav-item">
                <span class="icon" aria-hidden="true">
                  @switch (item.icon) {
                    @case ('dashboard') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/>
                        <rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/>
                      </svg>
                    }
                    @case ('users') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                      </svg>
                    }
                    @case ('box') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                        <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
                      </svg>
                    }
                    @case ('invoice') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                        <line x1="8" y1="13" x2="14" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/>
                      </svg>
                    }
                    @case ('truck') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="1" y="6" width="14" height="11" rx="1"/><path d="M15 9h4l3 3v5h-7"/>
                        <circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/>
                      </svg>
                    }
                    @case ('receipt') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 2v20l2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2V2z"/>
                        <line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="13" y2="16"/>
                      </svg>
                    }
                    @case ('refund') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 7 3 3 7 3"/><path d="M3 3l7 7"/>
                        <path d="M21 12a9 9 0 1 1-4.6-7.86"/>
                      </svg>
                    }
                    @case ('arrow-in') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 3v12"/><polyline points="6 11 12 17 18 11"/>
                        <line x1="3" y1="21" x2="21" y2="21"/>
                      </svg>
                    }
                    @case ('arrow-out') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 21V9"/><polyline points="6 13 12 7 18 13"/>
                        <line x1="3" y1="3" x2="21" y2="3"/>
                      </svg>
                    }
                    @case ('coins') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <ellipse cx="9" cy="7" rx="6" ry="3"/>
                        <path d="M3 7v4c0 1.66 2.69 3 6 3s6-1.34 6-3V7"/>
                        <path d="M3 11v4c0 1.66 2.69 3 6 3s6-1.34 6-3v-4"/>
                        <ellipse cx="15" cy="13" rx="6" ry="3"/>
                        <path d="M9 13v4c0 1.66 2.69 3 6 3s6-1.34 6-3v-4"/>
                      </svg>
                    }
                    @case ('refresh') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
                        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/>
                        <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/>
                      </svg>
                    }
                    @case ('card') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
                        <line x1="6" y1="15" x2="10" y2="15"/>
                      </svg>
                    }
                    @case ('book') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                      </svg>
                    }
                    @case ('list') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
                        <circle cx="4" cy="6" r="1"/><circle cx="4" cy="12" r="1"/><circle cx="4" cy="18" r="1"/>
                      </svg>
                    }
                    @case ('chart') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
                        <line x1="3" y1="20" x2="21" y2="20"/>
                      </svg>
                    }
                    @case ('building') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="4" y="3" width="16" height="18" rx="1"/>
                        <line x1="9" y1="8" x2="9" y2="8"/><line x1="15" y1="8" x2="15" y2="8"/>
                        <line x1="9" y1="12" x2="9" y2="12"/><line x1="15" y1="12" x2="15" y2="12"/>
                        <path d="M10 21v-4h4v4"/>
                      </svg>
                    }
                    @case ('gear') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="3"/>
                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                      </svg>
                    }
                  }
                </span>
                <span class="label">{{ item.label }}</span>
              </a>
            }
          </div>
        }
      </nav>
    </aside>

    <div class="main">
      <header class="topbar">
        <div class="topbar-left">
          <div class="page-title">{{ currentPageTitle() }}</div>
        </div>
        @if (isAuthenticated()) {
          <app-global-search />
        }
        <div class="topbar-actions">
          @if (isAuthenticated()) {
            <app-company-switcher />
          }
          @if (user(); as u) {
            <div class="user-menu">
              <button type="button" class="user-chip" (click)="toggleUserMenu($event)"
                      [attr.aria-expanded]="userMenuOpen()" aria-haspopup="menu">
                <span class="avatar">{{ (u.displayName ?? u.email)[0]?.toUpperCase() }}</span>
                <span class="user-name">{{ u.displayName ?? u.email }}</span>
                <span class="caret" [class.open]="userMenuOpen()">▾</span>
              </button>
              @if (userMenuOpen()) {
                <div class="user-dropdown" role="menu" (click)="$event.stopPropagation()">
                  <div class="user-dropdown-head">
                    <div class="name">{{ u.displayName ?? u.email }}</div>
                    @if (u.displayName) { <div class="email">{{ u.email }}</div> }
                  </div>
                  <a routerLink="/change-password" role="menuitem" class="item" (click)="closeUserMenu()">Change password</a>
                  <button type="button" role="menuitem" class="item danger" (click)="logout()">Sign out</button>
                </div>
              }
            </div>
          }
        </div>
      </header>
      <main class="content">
        <router-outlet />
      </main>
    </div>
  </div>
}
